import { useEffect } from 'react'
import { getAccessToken, getPermission } from '../services/Firebase'
import { isNativePlatform, getNativeToken, addNativeTokenRefreshListener } from '../services/Firebase/native'
import { isPushEnabled } from '../services/PushNotificationService'
import registerNotificationToken from '../services/NotificationTokenApi'

const useGetNotificationTokenAndSendToBackend = () => {
  useEffect(() => {
    let cleanup = () => {}

    const registerWeb = async () => {
      await getPermission()
      const token = await getAccessToken()
      await registerNotificationToken(token)
    }

    const registerNative = async () => {
      // The user can turn push off in Settings; registering a token here anyway
      // would quietly undo that on the next launch.
      if (!(await isPushEnabled())) return

      const token = await getNativeToken()
      await registerNotificationToken(token)
      // The switch can be flipped while this module is still open, and
      // deleting a token often makes FCM issue a fresh one - so the refresh
      // listener re-checks the preference instead of blindly re-registering.
      const listener = await addNativeTokenRefreshListener(async (refreshed) => {
        if (await isPushEnabled()) registerNotificationToken(refreshed)
      })
      cleanup = () => listener?.remove?.()
    }

    if (isNativePlatform()) {
      registerNative()
    } else {
      registerWeb()
    }

    return () => cleanup()
  }, [])
}

export default useGetNotificationTokenAndSendToBackend
